import { ROLES } from "utils/helpers/enums/roles.enum";
import { BADGE_ATTRIBUTE_AMBASSADOR, BADGE_ATTRIBUTE_ATTENDEE, BADGE_ATTRIBUTE_HOST, BAGDE_TYPES, CONDITION_OPTIONS, INDUSTRY_TYPES } from "utils/helpers/enums/shared.enum";
import { PictureDTO } from "../common/picture.dto";
import { format } from "date-fns";

export class BadgeDTO {
  id: number;
  badgeType: BAGDE_TYPES.EVENT | BAGDE_TYPES.ACHIEVEMENT | BAGDE_TYPES.CORE_CONCEPT;
  criteria: Criteria = new Criteria();
  imageId: number;
  imageUrl: string;
  name:string;
  industry: INDUSTRY_TYPES;
  image: PictureDTO = new PictureDTO();
  createdAt: string;
  badgeName: string;
  conditions: CONDITION_OPTIONS;
  attribute: BADGE_ATTRIBUTE_ATTENDEE | BADGE_ATTRIBUTE_AMBASSADOR | BADGE_ATTRIBUTE_HOST;
  attributeSet:number;
  forRole:string;
  coreConceptId: number;;


  constructor(data: Partial<BadgeDTO> = {}) {
    for (let key in data) {
      if (key === "criteria") {
        this[key] = new Criteria(data[key] ?? {});
      } else if (key === "image") {
        this[key] = new PictureDTO(data[key] ?? {});
      } else if (key === "createdAt") {
        this[key] = format(new Date(data[key]), "MMMM dd, yyyy, hh:mm a");
      } else {
        this[key] = data[key];
      }
    }
  }
}

export class Criteria {
  registrationDuration: string = "";
  eventCount: number = 0;
  forRole: ROLES;

  constructor(data: Partial<Criteria> = {}) {
    Object.assign(this, data);
  }
}
